<template>
  <div>
    <v-btn
      color="primary"
      dark
      class="mb-2"
      @click="editItem = {}"
    >
      Add Client
    </v-btn>
    <client-table-modal v-if="editItem" :edited-item="editItem" @close="editItem = null" />
    <v-data-table
      :headers="tableHeaders"
      :items="tableItems"
      class="elevation-1"
      item-key="clientName"
      disable-pagination
      hide-default-footer
    >
      <template v-slot:item="props">
        <tr>
          <td class="justify-center">
            <v-btn tooltip.hover title="Edit client" icon class="mx-0" @click="editItem = cloneDeep(props.item)">
              <v-icon color="primary">edit</v-icon>
            </v-btn>
          </td>
          <td>{{ props.item.clientName }}</td>
          <td>{{ props.item.clientNameDesc }}</td>
          <td style="word-wrap: break-word; max-width: 19em">{{ databaseItems[props.item.clientDatabaseId] ? databaseItems[props.item.clientDatabaseId].userName + '@' + databaseItems[props.item.clientDatabaseId].connectionUrl : props.item.clientDatabaseId }}</td>
          <td>
            <span v-show="props.item.trackingGroupTypeCd">
              Tracking Group Type Code: {{ props.item.trackingGroupTypeCd }} <br />
            </span>
            <span v-show="props.item.trackingGroupFilter">
              Tracking Group Filter: {{ props.item.trackingGroupFilter }} <br />
            </span>
            <span v-show="props.item.clientIdFilter">
              Client ID Filter: {{ props.item.clientIdFilter }} <br />
            </span>
            <span v-show="props.item.frxClientName">
              FirstRx Client Name: {{ props.item.frxClientName }}<br />
            </span>
            <span v-show="props.item.defaultSubmissionAllowAliasType">
              Default Submission Allow Alias Types: {{ props.item.defaultSubmissionAllowAliasType }}<br />
            </span>
            <span v-show="props.item.submissionAllowAliasType">
              Submission Allow Alias Types: {{ props.item.submissionAllowAliasType }}<br />
            </span>
            <span v-show="props.item.disabledDefaultAliasType">
              Disabled Default Alias Types: {{ props.item.disabledDefaultAliasType }}<br />
            </span>
            <span v-show="props.item.maskedAliasType">
              Masked Alias Type: {{ props.item.maskedAliasType }}<br />
            </span>
            <span v-show="props.item.drugCoverageOptions">
              Drug Coverage Options: {{ props.item.drugCoverageOptions }}<br />
            </span>
            <span v-show="props.item.disableUpdateCDHP">
              Disable Update CDHP: True<br />
            </span>
            <span v-show="props.item.disableRaceCd">
              Disable Race Code: True<br />
            </span>
            <span v-show="props.item.disablePersonCd">
              Disable Person Code: True<br />
            </span>
          </td>
          <td>{{ props.item.createdBy }}</td>
          <td>{{ props.item.createdOn | formatDate }}</td>
          <td>{{ props.item.lastModifiedBy }}</td>
          <td>{{ props.item.lastModifiedOn | formatDate }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>

import ClientTableModal from './ClientTableModal'
import cloneDeep from 'lodash/cloneDeep'
export default {
  name: 'client-table',
  components: {
    ClientTableModal
  },
  props: {
    tableItems: Array,
    databaseItems: Object
  },
  data() {
    return {
      editItem: null,
      tableHeaders: [{
        text: 'Actions',
        value: false,
        sortable: false
      }, {
        text: 'Client Name',
        value: 'clientName'
      },
      {
        text: 'Client Description',
        value: 'clientNameDesc'
      },
      {
        text: 'Database Info',
        value: 'clientDatabaseId'
      },
      {
        text: 'Client Properties',
        value: 'clientProperties',
        sortable: false
      },
      {
        text: 'Created By',
        value: 'createdBy'
      },
      {
        text: 'Created On',
        value: 'createdOn'
      },
      {
        text: 'Last Modified By',
        value: 'lastModifiedBy'
      },
      {
        text: 'Last Modified On',
        value: 'lastModifiedOn'
      }
      ]
    }
  },
  methods: {
    cloneDeep: cloneDeep
  }
}
</script>
